import React from 'react'
import styled from 'styled-components'
import Dialog from 'components/Dialog'
import {getDefaultValue} from 'utils/utils'

const Container = styled.span`
    width: 100%;
    height: 100%;
    padding: 0 10px;
    opacity: ${props => props.lookup ? 0.5 : 1};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

const Field = styled.textarea`
    resize: none;
    padding: 10px;
    width: 100%;
    height: 100%;
    line-height: 1.8;
    box-sizing: border-box;

    + div {
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        transform: scaleX(0);
        transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
        border-bottom: 2px solid #415dd4;
        pointer-events: none;
    }

    :focus {
        + div {
            transform: scaleX(1);
            display: block;
        }
    }
`

class Textarea extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            value: props.defaultValue
        }

    }

    componentDidUpdate(props) {
        if (this.props.defaultValue !== props.defaultValue) {
            this.setState({ value: this.props.defaultValue })
        }
    }

    handleClickOpen = () => {
        this.setState({ open: true })

        if (this.props.environment !== undefined && !this.state.value) {
            const value = getDefaultValue(this.props.environment, this.props.name, this.props.row)
            if (value) {
                this.setState({ value }, () => setTimeout(() => {
                    this.textarea.select()
                }, 5))
            }
        }
    }

    handleClickClose = () => {
        if (this.textarea.value !== this.state.value) {
            this.setState({ value: this.textarea.value }, () => this.props.handleUpdateValue(this.textarea.value, this.props.name))
        }

        this.setState({ open: false })
    }

    render() {
        return (
            <React.Fragment>
                <Container lookup={this.props.lookup} onClick={this.handleClickOpen}>
                    {this.state.value && this.state.value.length > 50 ? this.state.value.slice(0, 50) + '...' : this.state.value}
                </Container>
                <Dialog
					PaperProps={{
						sx: {
							height: '50%'
						}
					}}
                    fullWidth={true}
                    open={this.state.open}
                    onClose={this.handleClickClose}
                >
                    <Field
                        defaultValue={this.state.value}
                        spellCheck={false}
                        autoFocus
                        ref={el => this.textarea = el}
                        disabled={this.props.readonly}
                    />
                </Dialog>
            </React.Fragment>
        )
    }
}

export default Textarea
